import { memo, useCallback, useState } from 'react';
import { Paper } from '@mui/material';

import { ToolbarItem, ToolId } from '../types';
import { ToolbarNode } from './ToolbarNode';
import { HoverMenu } from './HoverMenu';
import { getNodeKey, hasSelectedTool } from '../helpers';
import { styles } from '../styles';

type Props = {
  items: ToolbarItem[];
  onSelectTool: (toolId: ToolId) => void;
  selectedToolId?: ToolId;
  disabled?: boolean;
};

function HoverToolbarComponent({ items, onSelectTool, selectedToolId, disabled = false }: Props) {
  const [lastSelectedMap, setLastSelectedMap] = useState<Record<string, ToolId>>({});

  const handleSelectedTool = useCallback(
    (toolId: ToolId) => {
      onSelectTool(toolId);
      const menu = items.find((it) => it.type === 'menu' && hasSelectedTool(it.items, toolId));
      if (menu && menu.type === 'menu') {
        setLastSelectedMap((prev) => ({ ...prev, [menu.label]: toolId }));
      }
    },
    [onSelectTool, items],
  );

  return (
    <Paper style={styles.toolbar}>
      {items.map((node, index) => {
        if (node.type === 'menu') {
          return (
            <HoverMenu
              key={getNodeKey(node, index)}
              menu={node}
              selectedToolId={selectedToolId}
              lastSelectedToolId={lastSelectedMap[node.label]}
              variant='tool'
              disabled={disabled}
              renderNode={(child) => (
                <ToolbarNode
                  node={child}
                  onSelectTool={handleSelectedTool}
                  selectedToolId={selectedToolId}
                  variant='menu'
                  disabled={disabled}
                />
              )}
            />
          );
        }

        return (
          <ToolbarNode
            key={getNodeKey(node, index)}
            node={node}
            onSelectTool={handleSelectedTool}
            selectedToolId={selectedToolId}
            variant='tool'
            disabled={disabled}
          />
        );
      })}
    </Paper>
  );
}

export const HoverToolbar = memo(HoverToolbarComponent);
